import qs from "qs";
import ApiClient, { ApiClientPromiseResponse } from "services/ApiClient";
import { ReportNote, UpdateDynamicReportNoteModel, UpdateReportNoteModel } from "types/reportNotes";

class ReportNotesService extends ApiClient {
  getReportNotes(projectId: string): ApiClientPromiseResponse<ReportNote> {
    return this.call<ReportNote>({
      method: "get",
      url: `/report-notes?${qs.stringify({ projectId })}`,
    });
  }

  getReportNotesPopulated(projectId: string) {
    return this.call({
      method: "get",
      url: `/report-notes/populated?${qs.stringify({ projectId })}`,
    });
  }

  updateReportNotes(reportNotesData: UpdateReportNoteModel | UpdateDynamicReportNoteModel, useDynamic: boolean = false): ApiClientPromiseResponse<{ id: string; }> {
    let url = "/report-notes";

    if (useDynamic) {
      url = `${url}/dynamic`;
    }

    return this.call({
      method: "put",
      url,
      data: {
        ...reportNotesData,
      },
    });
  }

  isTabAvailable(projectId: string): ApiClientPromiseResponse<boolean> {
    return this.call({
      method: "get",
      url: `/report-notes/is-tab-available?${qs.stringify({ projectId })}`,
    });
  }
}

export default new ReportNotesService();
